<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.attached_document') }}</v-tab>


            <v-tab-item>
              <v-layout>
                <ApplicationInformation
                  :receipt_no.sync = receipt_no
                />
              </v-layout>
              <h2 class="m_title">{{ $t('myrequest.view.fields.reason_of_change_ownership') }}</h2>
              <div class="v__radio__group__wrapper">
                <v-radio-group
                  row
                  v-model="typeCode"
                  class="view__radio"
                >
                  <template v-for="(code, i) in $vuetify.rtl ? typeCodeListAr : typeCodeListEn">
                    <v-radio

                      :key="code.value"
                      :label="code.text"
                      :value="code.value"
                      color="#a01c2a"
                      readonly
                    >
                    </v-radio>
                    <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                  </template>
                </v-radio-group>
              </div>

              <h2 class="m_title">{{ $t('modification.changeownership.fields.details') }}</h2>
              <div>
                <h2 class="m_title back__type">{{ $t('modification.changeownership.fields.applicant') }}</h2>
                <v-row class="mt-25">
                  <v-col cols="12" class="pb-0">
                    <div class="floating__title__self">{{ $t('common.button.before') }}</div>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-data-table
                      :headers="$getHeaderType1(headerTxt, applicantHeaders)"
                      :items="beforeApplicantList"
                      hide-default-footer
                      disable-pagination
                      class="new__type__table__view ty2 br_none"
                    >
                      <template v-slot:item="{ item, index }">
                        <tr>
                          <td class="text-center">
                            {{ index + 1 }}
                          </td>
                          <td>
                            <p>{{ item.name_ar }}</p>
                            <p>{{ item.name_en }}</p>
                          </td>
                          <td :class=" $vuetify.rtl ? 'text-right' : 'text-left'">
                            <p>{{ item.address_ar }}</p>
                            <p>{{ item.address_en }}</p>
                          </td>
                          <td>
                            {{ item.nationality_code }}
                          </td>
                          <td>
                            {{ item.residence_country_code }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row class="mt-25">
                  <v-col cols="12" class="pb-0">
                    <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-data-table
                      :headers="$getHeaderType1(headerTxt, applicantHeaders)"
                      :items="afterApplicantList"
                      hide-default-footer
                      disable-pagination
                      class="new__type__table__view ty2 disabled br_none"
                    >
                      <template v-slot:item="{ item, index }">
                        <tr>
                          <td class="text-center">
                            {{ index + 1 }}
                          </td>
                          <td>
                            <p>{{ item.name_ar }}</p>
                            <p>{{ item.name_en }}</p>
                          </td>
                          <td :class=" $vuetify.rtl ? 'text-right' : 'text-left'">
                            <p>{{ item.address_ar }}</p>
                            <p>{{ item.address_en }}</p>
                          </td>
                          <td>
                            {{ item.nationality_code }}
                          </td>
                          <td>
                            {{ item.residence_country_code }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </div>






            </v-tab-item>

            <v-tab-item>
              <DocumentViewer
                :items="documentFileList"
              />
            </v-tab-item>


          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation from '@/components/layout/ApplicationInformation'

export default {
  components :{
    ApplicationInformation,
    DocumentViewer
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],
      typeCode : '',
      typeCodeListAr: [],
      typeCodeListEn: [],
      headerTxt : {
        prefix : 'modification.changeownership.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },
      applicantHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('modification.changeownership.fields.name'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.changeownership.fields.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.changeownership.fields.nationality_country_code'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.changeownership.fields.residence_country_code'),  align: 'center', width: '98px', sortable: false, value: '' }
      ],
      beforeApplicantList : [],
      afterApplicantList : [],

    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetTypecode()
    this.fnGetContent()
    this.fnGetBeforeApplicantList()
    this.fnGetAfterApplicantList()
    this.fnGetDocumentFileList()
  },
  methods: {
    fnGetTypecode(){
      let options = {
        upper_code: '5400'
      }
      utils.fnGetCodeList(options).then(list => {
        this.typeCodeListAr = list.ar
        this.typeCodeListEn = list.en
      })
    },
    fnGetContent(){
      requestApi({
        url: '/receivings/change/ownership/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.typeCode = res.data.change_own_type_code
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetBeforeApplicantList(){
      requestApi({
        url: '/receivings/change/ownership/' + this.receipt_no + '/applicants/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAfterApplicantList(){
      requestApi({
        url: '/receivings/change/ownership/' + this.receipt_no + '/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.afterApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAfterApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  },
}
</script>